var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 15,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2565 4.35986H9.74023V10.6787H13.2565V4.35986Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96707 7.51856C9.96651 6.91002 10.1044 6.30932 10.3703 5.76195C10.6362 5.21458 11.0232 4.73488 11.5019 4.35917C10.9091 3.8932 10.1971 3.60342 9.44741 3.52295C8.69769 3.44248 7.94045 3.57457 7.26224 3.90412C6.58404 4.23367 6.01223 4.74739 5.61219 5.38655C5.21214 6.02571 5 6.76453 5 7.51856C5 8.27259 5.21214 9.01141 5.61219 9.65058C6.01223 10.2897 6.58404 10.8035 7.26224 11.133C7.94045 11.4626 8.69769 11.5946 9.44741 11.5142C10.1971 11.4337 10.9091 11.1439 11.5019 10.678C11.0232 10.3022 10.6363 9.82254 10.3703 9.27517C10.1044 8.7278 9.96652 8.12711 9.96707 7.51856Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9988 7.51856C17.9988 8.27258 17.7867 9.0114 17.3867 9.65056C16.9867 10.2897 16.4149 10.8034 15.7367 11.133C15.0585 11.4625 14.3013 11.5946 13.5515 11.5142C12.8018 11.4337 12.0899 11.1439 11.4971 10.678C11.9754 10.3019 12.362 9.82209 12.6279 9.2748C12.8938 8.72752 13.0319 8.12701 13.0319 7.51856C13.0319 6.91011 12.8938 6.30961 12.6279 5.76232C12.362 5.21504 11.9754 4.73526 11.4971 4.35917C12.0899 3.8932 12.8018 3.60342 13.5515 3.52295C14.3013 3.44248 15.0585 3.57457 15.7367 3.90413C16.4149 4.23368 16.9867 4.7474 17.3867 5.38656C17.7867 6.02573 17.9988 6.76454 17.9988 7.51856Z",
    fill: "#F79E1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6217 10.0105V9.8811H17.6739V9.85475H17.541V9.8811H17.5932V10.0105H17.6217ZM17.8796 10.0105V9.85449H17.8389L17.7921 9.96178L17.7452 9.85449H17.7045V10.0105H17.7332V9.89281L17.7771 9.99425H17.807L17.8509 9.89256V10.0105H17.8796Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardMastercard);
export default __webpack_public_path__ + "static/media/card_mastercard.ecc29d9fbd91af590e13af4fb0f23b13.svg";
export { ForwardRef as ReactComponent };